/* eslint-disable no-magic-numbers */

import { Link, useNavigate } from "react-router-dom";

import { routes } from "@/common/utils/routes";
import { nFormatter } from "@/common/utils/parseNumber";
import { className } from "@/common/utils/strings";
import { SeeAllButton } from "components/buttons";
import { Columnizer } from "components/blocks/Columnizer";
import ProfileIcon from "@/common/images/icons/profileIcon.svg?react";
import "./NicheListWidget.scss";
import { useSfw } from "@/common/hooks/useSfw";
import { NichePreviewClickInitiator } from "@/common/buses";
import { Button } from "@/components/buttons/Button/Button";

const LIST_SIZE = 4;
const COLUMN_SIZES = [500];

export interface INicheInfo {
  id: string;
  name: string;
  image: string | null;
  subscribers: number;
}

export const NicheListWidget = (props: {
  title: string;
  link: string;
  className?: string;
  niches: INicheInfo[];
  page: number;
  listSize?: number;
  onPreviewClick: (nicheId: string, initiator: NichePreviewClickInitiator) => void;
}) => {
  const { sanitizeImage, isLoading: isSfwLoading } = useSfw();

  const navigate = useNavigate();

  const listSize = props.listSize || LIST_SIZE;

  const onWatchClick = (item: INicheInfo) => () => {
    navigate(routes.niche(item.id));
    props.onPreviewClick(item.id, "watch button");
  };

  const isLoading = isSfwLoading;

  if (isLoading) {
    return null;
  }

  return (
    <div className={className({
      "nicheListWidget": true,
      [props.className ?? ""]: props.className !== undefined,
    })}>
      <div className="header">
        <h5 className="title">{props.title}</h5>
        <SeeAllButton link={props.link} />
      </div>

      <Columnizer className="rows" sizes={COLUMN_SIZES}>
        {props.niches.slice(
          props.page === 1 ? 0 : listSize * (props.page - 1), listSize * props.page
        ).map((el: INicheInfo) => {
          el.image = el.image ? sanitizeImage(el.image) : null;

          return (
            <div className="row" key={el.id}>
              <Link to={routes.niche(el.id)} className="pic" aria-label={`Link to ${el.id}`}
                onClick={() => props.onPreviewClick(el.id, "meta")}>
                {el.image ? <img loading="lazy" src={el.image} alt={el.name}/> : <ProfileIcon/>}
              </Link>
              <div className="title">
                <div className="name">
                  <Link to={routes.niche(el.id)}
                    onClick={() => props.onPreviewClick(el.id, "meta")}>{el.name}</Link>
                </div>
                <div className="subscribers">
                  <ProfileIcon/>
                  <span>{nFormatter(el.subscribers)}</span>
                </div>
              </div>
              <Button size="xs" onClick={onWatchClick(el)} aria-label="Watch">
                Watch
              </Button>
            </div>
          );
        })}
      </Columnizer>
      <div className="footer">
        <SeeAllButton link={props.link} />
      </div>
    </div>
  );
};
